import React from 'react';
import g from 'glamorous';
import { css } from 'glamor';
import Helmet from 'react-helmet';

import {
  normalMargin,
  largeMargin,
  largeBreakpoint
} from '../utils/layout-units';

import Banner from '../components/banner';
import ResponsiveMargin from '../components/responsive-margin';
import Sitenav from '../components/sitenav';
import heroUrl from './AuthorBioPageHero60@2x.jpg';
import sarahUrl from './SarahBook2.jpg';

const maxFloatLayout = '560px';

const ContentLayout = g.div({
  display: 'flex',
  [`@media (max-width: ${maxFloatLayout})`]: {
    display: 'block',
  },
});

const ImageWrapper = g.div({
  flex: '2',
  maxWidth: '288px',
  margin: `${normalMargin} 0 0 ${normalMargin}`,
  [`@media (min-width: ${largeBreakpoint})`]: {
    margin: `${largeMargin} 0 0 ${largeMargin}`,
  },
  [`@media (max-width: ${maxFloatLayout})`]: {
    float: 'right',
    margin: '0 16px',
  },
});

const SarahImage = g.img({
  minWidth: '160px',
  filter: 'drop-shadow(0 3px 4px rgba(0, 0, 0, 0.4))',
  transform: 'rotate(-3deg)',
  [`@media (max-width: ${maxFloatLayout})`]: {
    minWidth: '120px',
    width: '34vw',
  },
});

export default () => (
  <div>
    <Helmet title="Author Bio | Sarah Coleman" />
    <Banner imageUrl={heroUrl}/>
    <Sitenav/>
    <ContentLayout>
      <ImageWrapper>
        <SarahImage src={sarahUrl}/>
      </ImageWrapper>
      <ResponsiveMargin css={{flex: '3'}}>
        <h2>Author Bio</h2>
        <p>Sarah Coleman wrote about photography, visual art and film for publications including <i>ARTnews</i>, <i>Salon</i>, <i>Communication Arts</i>, <i>Photo District News</i> and <i>View Camera</i>. She received a Masters of Fine Arts in creative writing from Columbia University and was a resident artist at Yaddo, Ragdale, the Vermont Studio Center and the Virginia Center for Creative Arts. She blogged about photography and literature at <a href="http://theliteratelens.com">theliteratelens.com</a>, and lived in Manhattan and Woodstock, NY with her husband and two children. Sarah died from lung cancer, shortly after completing The Realist, in December 2017.</p>
      </ResponsiveMargin>
    </ContentLayout>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/author-bio.js